import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiScissors, FiDroplet, FiHeart, FiCheck, FiArrowRight, FiSearch, FiMessageCircle } = FiIcons;

const Services = () => {
  const fullServices = [
    {
      title: 'Banho e Tosa em Juiz de Fora',
      id: 'banho-tosa',
      icon: FiScissors,
      desc: 'Oferecemos o serviço de banho e tosa mais completo da cidade. Especialistas em todas as raças com foco no bem-estar e baixo estresse sob supervisão veterinária.',
      details: [
        'Tosa na Tesoura e Máquina Profissional',
        'Banho com produtos Hydra e Artero',
        'Corte de unhas e limpeza de ouvidos',
        'Finalização com perfumes hipoalergênicos'
      ]
    },
    {
      title: 'Estética Animal Especializada',
      id: 'estetica',
      icon: FiDroplet,
      desc: 'Tratamentos de pelagem que vão além da estética. Hidratações profundas e banhos terapêuticos assistidos por nossa equipe técnica.',
      details: [
        'Hidratação Intensiva de Pelagem',
        'Tratamento para peles sensíveis',
        'Desembolamento sem dor',
        'Escovação dentária opcional'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 mb-6">
            Serviços de <span className="text-blue-600">Estética Profissional</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed font-medium">
            Confira por que somos a escolha número 1 em Juiz de Fora para quem busca qualidade técnica e segurança para seu pet.
          </p>
        </div>

        {/* CTA Quiz */}
        <div className="mb-16 bg-blue-900 rounded-[40px] p-8 md:p-12 text-white flex flex-col md:flex-row items-center justify-between gap-8">
           <div className="text-center md:text-left">
              <h3 className="text-2xl font-bold mb-2">Dúvida sobre qual serviço escolher?</h3>
              <p className="text-blue-100">Use nosso quiz e descubra o ideal para seu pet em segundos.</p>
           </div>
           <a href="https://quiz.unipet.online/" target="_blank" rel="noopener noreferrer" className="bg-white text-blue-900 px-8 py-4 rounded-2xl font-bold flex items-center gap-2 hover:bg-gray-100 transition-all">
             <SafeIcon icon={FiSearch} /> Abrir Quiz de Serviços
           </a>
        </div>

        <div className="grid gap-12">
          {fullServices.map((service, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="bg-white rounded-[40px] p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col lg:flex-row gap-12"
            >
              <div className="lg:w-1/3">
                <div className="w-20 h-20 bg-blue-900 text-white rounded-3xl flex items-center justify-center mb-8 shadow-xl shadow-blue-900/10">
                  <SafeIcon icon={service.icon} className="w-10 h-10" />
                </div>
                <h2 className="text-3xl font-extrabold text-gray-900 mb-4 leading-tight">{service.title}</h2>
                <p className="text-gray-600 text-lg leading-relaxed font-medium">
                  {service.desc}
                </p>
              </div>

              <div className="lg:w-2/3 bg-blue-50/30 rounded-[32px] p-8 md:p-12">
                <h4 className="text-xs font-black text-blue-900 uppercase tracking-[0.2em] mb-8">Benefícios UniPET:</h4>
                <div className="grid sm:grid-cols-2 gap-8">
                  {service.details.map((detail, idx) => (
                    <div key={idx} className="flex items-start space-x-4">
                      <div className="mt-1 bg-green-500 rounded-full p-1.5 flex-shrink-0">
                        <SafeIcon icon={FiCheck} className="w-3 h-3 text-white" />
                      </div>
                      <span className="text-gray-800 font-bold text-lg">{detail}</span>
                    </div>
                  ))}
                </div>
                
                <div className="mt-12 flex items-center justify-between border-t border-blue-100 pt-8">
                  <a href="https://wa.me/5532999857587" target="_blank" rel="noopener noreferrer" className="bg-blue-900 text-white px-8 py-4 rounded-2xl font-bold hover:bg-blue-950 transition-all flex items-center gap-2 shadow-lg shadow-blue-900/10">
                    Chamar no WhatsApp <SafeIcon icon={FiMessageCircle} />
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;